import axios from "axios";
import { BASE_URL } from "../baseurl";

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
});

const customPagesApi = {
  async list() {
    const response = await axios.get(`${BASE_URL}/custom-pages`);
    return response.data.pages;
  },
  async get(slug) {
    const response = await axios.get(`${BASE_URL}/custom-pages/${slug}`);
    return response.data.page;
  },
  async create(page) {
    const response = await axios.post(`${BASE_URL}/custom-pages`, page, { headers: authHeaders() });
    return response.data.page;
  },
  async update(id, page) {
    const response = await axios.put(`${BASE_URL}/custom-pages/${id}`, page, { headers: authHeaders() });
    return response.data.page;
  },
  async remove(id) {
    return axios.delete(`${BASE_URL}/custom-pages/${id}`, { headers: authHeaders() });
  },
};

export default customPagesApi;